import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-c4b82716")

_pushScopeId("data-v-c4b82716")
const _hoisted_1 = { class: "overlay stat-placement" }
const _hoisted_2 = { class: "t-4 stat-placement__title" }
const _hoisted_3 = { class: "default-btn stat-placement__label" }
const _hoisted_4 = { class: "stat-placement__content" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LineChart = _resolveComponent("LineChart")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('main.bulletinstat')), 1),
    _createVNode("div", {
      class: "stat-placement__subtitle",
      innerHTML: _ctx.$t('main.namebulletin.text', [$setup.totalCount])
    }, null, 8, ["innerHTML"]),
    _createVNode("div", _hoisted_3, _toDisplayString($setup.labelTitle), 1),
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_LineChart, {
        type: 'line',
        data: {
        labels: $setup.labels,
        datasets: [
          {
            data: $setup.data,
            lineTension: 0,
            backgroundColor: [
              'rgba(38, 221, 191, 0.2)',
              'rgba(38, 221, 191, 0.2)',
              'rgba(38, 221, 191, 0.2)',
              'rgba(38, 221, 191, 0.2)',
              'rgba(38, 221, 191, 0.2)',
              'rgba(38, 221, 191, 0.2)',
              'rgba(38, 221, 191, 0.2)',
              'rgba(38, 221, 191, 0.2)',
              'rgba(38, 221, 191, 0.2)',
              'rgba(38, 221, 191, 0.2)',
              'rgba(38, 221, 191, 0.2)',
              'rgba(38, 221, 191, 0.2)',
              'rgba(38, 221, 191, 0.2)',
              'rgba(38, 221, 191, 0.2)',
              'rgba(38, 221, 191, 0.2)',
              'rgba(38, 221, 191, 0.2)',
              'rgba(38, 221, 191, 0.2)',
              'rgba(38, 221, 191, 0.2)',
              'rgba(38, 221, 191, 0.2)',
              'rgba(38, 221, 191, 0.2)'
            ],
            borderColor: [
              'rgba(38, 221, 191, 1)',
              'rgba(38, 221, 191,, 1)',
              'rgba(38, 221, 191, 1)',
              'rgba(38, 221, 191, 1)',
              'rgba(38, 221, 191, 1)',
              'rgba(38, 221, 191, 1)',
              'rgba(38, 221, 191, 1)',
              'rgba(38, 221, 191, 1)',
              'rgba(38, 221, 191, 1)',
              'rgba(38, 221, 191, 1)',
              'rgba(38, 221, 191, 1)',
              'rgba(38, 221, 191, 1)',
              'rgba(38, 221, 191, 1)',
              'rgba(38, 221, 191, 1)',
              'rgba(38, 221, 191, 1)',
              'rgba(38, 221, 191, 1)',
              'rgba(38, 221, 191, 1)',
              'rgba(38, 221, 191, 1)',
              'rgba(38, 221, 191, 1)',
              'rgba(38, 221, 191, 1)'
            ],
            borderWidth: 1
          }
        ]
      },
        options: {
  responsive: true,
  maintainAspectRatio: false,
  steppedLine: false,
  legend: {
    display: false
  },
  scales: {
    yAxes: [
      {
        ticks: {
          beginAtZero: true
        }
      }
    ],
    xAxes: [
      {
        ticks: {
          maxRotation: 90,
          minRotation: 90
        }
      }
    ]
  }
}
      }, null, 8, ["data"])
    ])
  ]))
})